export const m012Definition = {
  id: "M-012",
  title: "WebSocket & Realtime Subscription Cycle",
  description:
    "Full lifecycle of a realtime WebSocket connection: Connect, Register Client, Subscribe to Channels, Receive Broadcasts on DB Record Changes, Unsubscribe, and Disconnect.",
  participants: [
    { id: "Client", label: "Client App" },
    { id: "WS", label: "WS / SSE Server" },
    { id: "Broker", label: "Realtime Broker" },
    { id: "DB", label: "SQLite DB" },
  ],
  messages: [
    { id: "m1", from: "Client", to: "WS", label: "1. Connect /api/realtime" },
    { id: "m2", from: "WS", to: "Broker", label: "2. Register Client Connection" },
    { id: "m3", from: "Client", to: "WS", label: "3. Subscribe (collections.posts)" },
    { id: "m4", from: "WS", to: "Broker", label: "4. Add Client to Channel" },
    { id: "m5", from: "DB", to: "Broker", label: "5. Record Created / Updated" },
    { id: "m6", from: "Broker", to: "WS", label: "6. Broadcast Event Payload" },
    { id: "m7", from: "WS", to: "Client", label: "7. Push Event (create/update)", isResponse: true },
    { id: "m8", from: "Client", to: "WS", label: "8. Unsubscribe" },
    { id: "m9", from: "WS", to: "Broker", label: "9. Remove from Channel" },
    { id: "m10", from: "Client", to: "WS", label: "10. Disconnect Connection" },
    { id: "m11", from: "WS", to: "Broker", label: "11. Cleanup Client Session" },
  ],
};
